export enum SubscriptionType {
  Free = 1,
  OldMonth = 2, // была в прошлой версии, по 450/мес., больше не активна, но старые подписки поддерживаются
  Month = 3,
  SixMonth = 4,
  Year = 5,
  ExternalFree = 6,
  ExternalPaid = 7,
}

export const getDescriptionByType = (type: SubscriptionType, withGenerations: boolean): string => {
  return getMonthCostByType(type, withGenerations) + ' ₽ в месяц'
}

export const getButtonTextByType = (type: SubscriptionType, withGenerations: boolean): string => {
  const countMonths = getCountMonthsByType(type)
  const cost = getCostByType(type, withGenerations)
  if (countMonths === 1) {
    return 'Оплатить'
  }
  return 'Оплатить ' + cost + ' ₽ / ' + countMonths + ' мес'
}

export const getCostByType = (type: SubscriptionType, withGenerations: boolean): string => {
  switch (type) {
  case SubscriptionType.OldMonth:
    return withGenerations ? '990' : '450'
  case SubscriptionType.Month:
    return withGenerations ? '990' : '490'
  case SubscriptionType.SixMonth:
    return withGenerations ? '4 752' : '2 352'
  case SubscriptionType.Year:
    return withGenerations ? '7 128' : '3 528'
  default:
    return ''
  }
}

export const getMonthCostByType = (type: SubscriptionType, withGenerations: boolean): string => {
  switch (type) {
  case SubscriptionType.OldMonth:
    return '450'
  case SubscriptionType.Month:
    return withGenerations ? '990' : '490'
  case SubscriptionType.SixMonth:
    return withGenerations ? '792' : '392'
  case SubscriptionType.Year:
    return withGenerations ? '594' : '294'
  default:
    return ''
  }
}

export const getUpgradeCostByType = (type: SubscriptionType): string => {
  switch (type) {
  case SubscriptionType.OldMonth:
    return '500'
  case SubscriptionType.Month:
    return '500'
  case SubscriptionType.SixMonth:
    return '2400'
  case SubscriptionType.Year:
    return '3600'
  default:
    return ''
  }
}

export const getCountMonthsByType = (type: SubscriptionType): number => {
  switch (type) {
  case SubscriptionType.Year:
    return 12
  case SubscriptionType.SixMonth:
    return 6
  default:
    return 1
  }
}

export const getDurationByType = (type: SubscriptionType): string => {
  switch (type) {
  case SubscriptionType.Year:
    return '12 месяцев'
  case SubscriptionType.SixMonth:
    return '6 месяцев'
  default:
    return '1 месяц'
  }
}
